import { render, staticRenderFns } from "./ToggleWrapper.vue?vue&type=template&id=19549203&"
import script from "./ToggleWrapper.vue?vue&type=script&lang=js&"
export * from "./ToggleWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19549203')) {
      api.createRecord('19549203', component.options)
    } else {
      api.reload('19549203', component.options)
    }
    module.hot.accept("./ToggleWrapper.vue?vue&type=template&id=19549203&", function () {
      api.rerender('19549203', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/ToggleWrapper.vue"
export default component.exports